import script from "./ListarVendas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarVendas.vue?vue&type=script&setup=true&lang=js"

import "./ListarVendas.vue?vue&type=style&index=0&id=ffd3bdf2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffd3bdf2"]])

export default __exports__